__webpack_require__.p = "/stream/_next/";